// extracted by mini-css-extract-plugin
export default {"bleed--true":"DXnqTxzoLNsk4rxSBscf","bleed--0":"qnZE6DGdlsJgSis6DdHU"};